import { Avatar, Box, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import React from 'react'
import { PRIMARY_COLOR_MediumRoyalBlue } from '../../../constants/Colors';
import { useTheme} from "@mui/material/styles";
import { getAPIEndpointUrl } from '../../../utils/ServerRequestModifier';
import draftToHtml from 'draftjs-to-html';

const DetailModal = ({ open1, handleClose1, item }) => {

    const theme = useTheme();

  return (
    <Dialog open={open1} onClose={handleClose1} maxWidth="md">
      <DialogTitle></DialogTitle>
      <DialogContent>
        <Box
          display={"flex"}
          gap={4}
          borderRadius={1.5}
          padding={2}
        >
          <Box flex={1}>
            <Avatar
              sx={{ width: "100%", height: "100%", borderRadius: "5px" }}
              src={getAPIEndpointUrl() + item.image}
            />
          </Box>
          <Box flex={1} sx={{display: 'flex', flexDirection: 'column'}}>
            <div style={{maxHeight: '60vh', overflow: 'auto'}}>
              <Typography variant="h6" dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(item.description)) }} />
            </div>
            <Stack gap={3}>
              <Stack>
                <Typography color={PRIMARY_COLOR_MediumRoyalBlue}>
                  {item.name}
                </Typography>
                <Typography>{item.designation}</Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default DetailModal